/**
 * @generated SignedSource<<27112f9e26bc4ce83bacf6815ea33c90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsRowLongText$data = {
  readonly label: string;
  readonly subTitle: string | null;
  readonly text: string | null;
  readonly " $fragmentType": "ProductDetailsRowLongText";
};
export type ProductDetailsRowLongText$key = {
  readonly " $data"?: ProductDetailsRowLongText$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowLongText">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsRowLongText",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTitle",
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentLongTextRow",
  "abstractKey": null
};

(node as any).hash = "6c8c573a8d857f88f1cbd4528736e932";

export default node;
